import {ChartConfiguration} from "chart.js";
import {ColorPaletteParams} from "../types/line-chart-modal.types";

export const defaultLineChart = {
  labels: [],
  datasets: []
};

export const optionLineChat: ChartConfiguration['options'] = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top'
    },
    tooltip: {
      mode: 'index',
      intersect: true,
      position: 'nearest'
    }
  },
  scales: {
    y: {
      beginAtZero: true
    },
    x: {
      title: {
        display: true
      }
    }
  }
};

export const getColorPalette = (size: number): Array<ColorPaletteParams> => {
  return Array.from({ length: size }, (_, i) => {
    const hue = (i * 137.507764) % 360;
    const saturation = 100;
    const lightness = 40 + (i % 7) * 8;

    return {
      border: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
      background: `hsla(${hue}, ${saturation}%, ${lightness}%, 0.4)`
    };
  });
};
